export default "__VITE_ASSET__c0519e5e__"